import { Component, OnInit } from '@angular/core';
import { IonContent, IonHeader, IonIcon, IonLabel, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
	selector: 'app-contact-us',
	templateUrl: './contact-us.component.html',
	styleUrls: ['./contact-us.component.scss'],
	standalone: true,
	imports: [IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonIcon],
})
export class ContactUsComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
